var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCameraSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 10.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75H6zM6.76 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10.48c2.02 0 3.11-1.03 3.24-3.05L21 9.94a2.94 2.94 0 0 0-.59-1.98.75.75 0 0 1 1.2-.9c.64.86.96 1.91.89 2.98l-.52 8.26c-.18 2.83-1.91 4.45-4.74 4.45H6.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.81 20.87c-.46-.7-.73-1.57-.79-2.58l-.52-8.25a4.44 4.44 0 0 1 1.21-3.36C3.56 5.77 4.76 5.25 6 5.25c.32 0 .63-.19.78-.49l.72-1.43c.59-1.17 2.07-2.08 3.36-2.08h2.29c1.29 0 2.76.91 3.35 2.07l.72 1.46c.15.28.45.47.78.47.41 0 .75.34.75.75s-.34.75-.75.75c-.89 0-1.7-.5-2.12-1.29L15.15 4c-.33-.66-1.27-1.24-2.01-1.24h-2.29c-.74 0-1.68.58-2.02 1.25l-.71 1.43C7.7 6.25 6.89 6.75 6 6.75c-.84 0-1.62.34-2.2.95-.57.61-.86 1.41-.8 2.24l.52 8.26c.04.73.23 1.37.55 1.84a.753.753 0 0 1-1.26.83zM9.54 17.9a.75.75 0 0 1 .92-1.18 2.5 2.5 0 0 0 4.04-1.97c0-.48-.13-.94-.38-1.33a.758.758 0 0 1 .23-1.04c.35-.22.81-.12 1.04.23.4.63.62 1.37.62 2.13A4.016 4.016 0 0 1 12 18.75c-.89 0-1.76-.3-2.46-.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47 22.53a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.15.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCameraSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-camera-slash.c7734b1cb7f5f6c0c77396ae4ba42d0e.svg";
export { ForwardRef as ReactComponent };